import React, { useState, Fragment, useContext } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Chip,
  Box,
  Typography,
  IconButton,
  Avatar,
  useTheme,
} from "@mui/material";
import EditarEliminarComentario from "./editar_eliminar";
import LikesAndDislikes from "./likesAndDislikes";
import { DashboardContext } from "../../../../context/dashboar_context";
import moment from "moment";
import "moment/locale/es-mx";
import CustomAvatar from "../../../../components/CustomAvatar";
import { Done, MoreVert } from "@mui/icons-material";

export default function RespuestasComentarios({
  comentario,
  respuesta,
  update,
  setUpdate,
}) {
  const theme = useTheme();
  let user = { _id: "" };
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = useState(null);
  const { curso } = useContext(DashboardContext);

  if (token !== null) user = JSON.parse(localStorage.getItem("student"));

  /* menu de respuesta */
  const handleClickMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  return (
    <Fragment>
      <EditarEliminarComentario
        comentario={comentario}
        anchorEl={anchorEl}
        handleCloseMenu={handleCloseMenu}
        update={update}
        setUpdate={setUpdate}
        commentOrAnswer="answer"
        respuesta={respuesta}
      />
      <Card sx={{ paddingLeft: theme.spacing(5) }}>
        <CardHeader
          avatar={
            respuesta.idUser.urlImage ? (
              <Avatar
                aria-label="recipe"
                alt="imagen user"
                src={respuesta.idUser.urlImage}
              />
            ) : (
              <CustomAvatar name={respuesta.idUser.name} />
            )
          }
          action={
            respuesta.idUser?._id === user?._id ? (
              <IconButton
                aria-label="settings"
                onClick={(e) => handleClickMenu(e)}
              >
                <MoreVert />
              </IconButton>
            ) : null
          }
          title={
            <Box display="flex">
              <Box mr={1}>
                <Typography>{respuesta.idUser.name}</Typography>
              </Box>
              {respuesta.idUser?._id === curso.course.idProfessor._id ? (
                <Chip
                  size="small"
                  variant="outlined"
                  icon={<Done />}
                  label="INSTRUCTOR"
                  color="primary"
                />
              ) : null}
            </Box>
          }
          subheader={moment(respuesta.createComment).format("LLL")}
        />
        <CardContent>
          <Typography variant="body2" color="textSecondary" component="p">
            {respuesta.comment}
          </Typography>
        </CardContent>
        <CardActions>
          <LikesAndDislikes
            update={update}
            setUpdate={setUpdate}
            comentario={comentario}
            respuesta={respuesta}
          />
        </CardActions>
      </Card>
    </Fragment>
  );
}
